const tables = [
  {
    name: "Date",
  },
  {
    name: "Name",
  },
  {
    name: "Role",
  },
  {
    name: "Email",
  },
  {
    name: "Phone",
  },
  {
    name: "Action",
  },
];

export default tables;
